/**
 * 법률 문서 섹션 카드 컴포넌트
 *
 * 개별 섹션(제목 + 내용)을 렌더링합니다.
 */

import type { LegalSection } from './types';

interface LegalSectionCardProps {
  section: LegalSection;
  /** 문단 들여쓰기 판별 함수 (옵션) */
  shouldIndent?: (paragraph: string) => boolean;
}

/** 기본 들여쓰기 판별 함수 */
const defaultShouldIndent = (paragraph: string): boolean => {
  return (
    paragraph.startsWith('•') ||
    paragraph.startsWith('(') ||
    paragraph.startsWith('"') ||
    /^\d+\.\d+\./.test(paragraph)
  );
};

export function LegalSectionCard({
  section,
  shouldIndent = defaultShouldIndent,
}: LegalSectionCardProps) {
  return (
    <div className="bg-background rounded-lg p-5 border border-border">
      <h2 className="text-foreground mb-4">
        {section.title}
      </h2>
      <div className="space-y-3">
        {section.content.map((paragraph, pIndex) => (
          <p
            key={pIndex}
            className={`text-foreground text-sm leading-relaxed ${
              shouldIndent(paragraph) ? 'pl-4' : ''
            } ${paragraph === '' ? 'h-2' : ''}`}
          >
            {paragraph}
          </p>
        ))}
      </div>
    </div>
  );
}
